import React from 'react'
import {observer, inject} from 'mobx-react'
import Back from 'components/common/back/Back'
import * as antdMobile from 'antd-mobile';
import * as antd from "antd";
import {addAfterSale} from "utils/api/api";
import {useParams, useHistory} from 'react-router-dom';
// import '@/styles/refund-apply.scss';
import css from './css/refundApply.module.scss'

const RefundApply = () => {


    const [form] = antd.Form.useForm()
    const {getFieldProps, getFieldError} = form;

    const params = useParams();
    const orderId = Number(params.id);
    const history = useHistory();


    const onFinish = (values) => {
        try {
            const {reason} = values;

            addAfterSale({orderId, reason}).then(() => {
                antd.message.success("提交成功").then();
                history.goBack();
            })
        } catch (e) {
        } finally {
        }
        // form.validateFields((errors, values) => {
        //     if (errors) {
        //         for (let key in errors) {
        //             message.error(errors[key].errors?.[0].message);
        //             return;
        //         }
        //     }
        //
        //
        // });
    }

    const formInitialValues = {
        reason: '',
    }

    return (
        <div className={css.refundApply}>
            <Back>
                <div className="">申请退款</div>
            </Back>
            <antd.Form form={form} className={css.antdRefundForm} initialValues={formInitialValues} onFinish={onFinish}>
                <antdMobile.List>
                    <antd.Form.Item className={css.formItem}>
                        <antd.Form.Item
                            noStyle
                            name='reason'
                            rules={
                                [
                                    {required: true, message: '请填写退款原因'}
                                ]
                            }
                        >
                            <antdMobile.TextareaItem
                                clear
                                title='退款原因'
                                placeholder="请输入退款原因"
                                rows={4}
                            />
                        </antd.Form.Item>
                    </antd.Form.Item>
                </antdMobile.List>

                <antd.Form.Item noStyle>
                    <div className={css.btnFloor}>
                        <button type={"submit"} className={css.btnSubmit}>申请退款</button>
                    </div>
                </antd.Form.Item>
            </antd.Form>
        </div>
    )
}

export default inject('address')(observer(RefundApply));
